<template>
    <div class="icon-renderer">
        <v-tooltip v-if="params.value.tooltipText" z-index="300" bottom>
            <template v-slot:activator="{ props }">
                <span v-bind="props">
                    <icon
                        class="icon-renderer__icon"
                        :icon-name="params.value.icon"
                        :color="params.value.color"
                    />
                    <span v-if="params.value.text" class="icon-renderer__text">
                        {{ toSentenceCase(params.value.text) }}
                    </span>
                </span>
            </template>
            <span>{{ params.value.tooltipText }}</span>
        </v-tooltip>
        <span v-else>
            <icon
                class="icon-renderer__icon"
                :icon-name="params.value.icon"
                :color="params.value.color"
            />
            <span v-if="params.value.text" class="icon-renderer__text">
                {{ toSentenceCase(params.value.text) }}
            </span>
        </span>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({});
</script>

<style lang="scss">
.icon-renderer {
    &__text {
        padding-left: 1rem;
    }
}
</style>
